<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './components/header/header'
  import Footer from './components/footer/footer'
export default {
  name: 'App',
  components:{
    Header,
    Footer
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}
@media (min-width: 1800px) {
  #app {
    width: 70%;
    margin: 0 auto;
  }
}

@media (min-width: 1550px) and (max-width:1799px){
  #app {
    width: 80%;
    margin: 0 auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue